class GameDirective {
    constructor() {
        this.restrict = 'A';
        this.scope = {};
    }
    link(scope, element) {
        this.resize(element);
        window.onresize = ()=>{
            this.resize(element);
        };
    }
    resize(element){
        const height = window.innerHeight;
        let elementHeight = height/2;
        let ratio = 1200/450;
        const maxWidth = window.innerWidth;
        let calcWidth = elementHeight*ratio;
        if(calcWidth>maxWidth){
            calcWidth = maxWidth;
        }
        element.css('width',calcWidth+'px');
    }
}

export default GameDirective;


// WEBPACK FOOTER //
// ./public/app/game/game.directive.js